// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1rHir","boxTitle":"Qualiphy_boxTitle__2qyRJ","box":"Qualiphy_box__2PEYx","toggleWrap":"Qualiphy_toggleWrap__WHVHs"};